import React, { useState, useEffect,useMemo} from 'react'
import Select from 'react-select'
import { SlButton, SlOption, SlSelect, SlTab, SlTabGroup, SlTabPanel,SlDrawer} from '@shoelace-style/shoelace/dist/react';
import { formatAmount, languageOptions, roles } from "../../utils/constants";
import LocationImage from "../../assets/images/location.png"
import Datepicker from "react-tailwindcss-datepicker";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router';
import NoDataFound from "../../shared/NoDataFound";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import TableSkelton from '../../shared/TableSkelton';
import { formatDate } from "../../utils/dateFormat";
import Button from 'react-bootstrap/Button';
import NoImage from "../../assets/images/NoImage.png";
import LocationSVG from "../../assets/images/location.svg";
import { Modal } from "react-bootstrap";

import { Toast } from '../../shared/Toast';
import * as XLSX from 'xlsx'
import AdsPreviewer from './AdsPreviewer';

const AlphaCompetitor_reports = ()=>{
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Subtract 7 days
    const navigate = useNavigate();
    
    const formatFullDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
   
   const [activeTab, setActiveTab] = useState("revenue_estimates")
   const formattedStartDate = formatFullDate(sevenDaysAgo);
   const formattedEndDate = formatFullDate(today);
   const [revenueStats, setRevenueStats] = useState({});
   const [newspaperData, setNewsPaperData] = useState([]);
   const [w2nData, setW2nData] = useState({})
   const [source, setSource] = useState("Media");
   const [dateRange, setDateRange] = useState({ startDate: formattedStartDate, endDate: formattedEndDate });
   const [regionDateRange, setRegionDateRange] = useState({ startDate: formattedStartDate, endDate: formattedEndDate });
   const [revenueEstimates, setRevenueEstimates] = useState([]);
   const [selectedSources, setSelectedSources] = useState(["Eenadu"]);
   const [queryLang, setQueryLang] = useState(['1']);
   const startDate = new Date(regionDateRange.startDate); 
   const endDate = new Date(regionDateRange.endDate);
   const dateArray = [];
   const [locations, setLocations] = useState([]);
   const [queryLocation, setQueryLocation] = useState([]);
   const [queryMedia, setQueryMedia] = useState([]);
   const [queryDateRange, setQueryDateRange] = useState({ startDate: formattedStartDate, endDate: formattedEndDate });
   const [queryCategory, setQueryCategory] = useState([]);
   const [querySubCategory, setQuerySubCategory] = useState([])
   const [categories, setCategories] = useState([]);
   const [subCategoriesMain, setSubCategoriesMain] = useState([])
   const [subCategories, setSubCategories] = useState([])
   const [regionReports, setRegionReports] = useState([])
   const [loader, setLoader] = useState(false);
   const [languages, setLanguages] = useState([]);
   const [userType, setUserType] = useState("");
   
   const [totalcompetitorvalue,settotalcompetitorvalue] = useState(0);
   const [totalway2value,settotalway2value] = useState(0);
   const [queryData, setQueryData] = useState({});

   const [open, setOpen] = useState(false);
   const [CampaignList, setCampaignList] = useState([]);
   const [imgSrc, setImgSrc] = useState("")
   const [see, setSee] = useState(false);
   const [newspaperLocationsObject, setNewspaperLocationsObject] = useState([])
   const [showPreviews,setShowPreviews] = useState(false)
   const [showW2nPreviews, setShowW2npreviews] = useState(false)
   const [compPreviewData, setCompPreviewData] = useState([])
   const [W2nPreviewData, setW2nPreviewData] = useState([])
   const [previewLoader, setPreviewLoader] = useState(false)
   const [districts, setDistricts] = useState([])
   const [selectedDistricts, setSelectedDistricts] = useState();
   const [selectedQuery, setSelectedQuery] = useState("district_wise")

   const getDistricts = async()=>{
    const lang_ids = languageOptions
        .filter(lang => lang.label === "Telugu")
        .map(lang => lang.value);
    try {
        const res = await api({ url: `/birdview/getDistrictsByLang`, method: "POST", data: {lang_ids} });
        if (res.code === 200) setDistricts(res.data);
      } catch (error) {}
}


   
   for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
    dateArray.push(formattedDate);
   }
  
    function calculatePercentage(value, total) {
        if (total === 0) {
            return 0;
        }

        const percentage = (value / total) * 100;
        return parseFloat(percentage.toFixed(2));
    }

   const handleQueryLang = (lang) => {
    setQueryLang(lang);
   }
   const handleQueryDateRange = (selectedDate) => {
    if (selectedDate) {
        if (selectedDate.startDate && selectedDate.endDate) {
            setQueryDateRange(selectedDate);
        } else {
            setQueryDateRange({ startDate: null, endDate: null });
        }
    } else {
        setQueryDateRange({ startDate: null, endDate: null });
    }
   }
   const handleDateRange = (selectedDate) => {
    if (selectedDate) {
        if (selectedDate.startDate && selectedDate.endDate) {
            setDateRange(selectedDate);
        } else {
            setDateRange({ startDate: null, endDate: null });
        }
    } else {
        setDateRange({ startDate: null, endDate: null });
    }
   }
   const handleRegionDateRange = (selectedDate) => {
    if (selectedDate) {
        if (selectedDate.startDate && selectedDate.endDate) {
            setRegionDateRange(selectedDate);
        } else {
            setRegionDateRange({ startDate: null, endDate: null });
        }
    } else {
        setRegionDateRange({ startDate: null, endDate: null });
    }
   }
   const handleTabClick = (tabName) => {
    setActiveTab(tabName);
   };
   const handleSourceChange = (value) => {
    setSelectedSources(value)
   };
   function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
        event.preventDefault();
    }
   }
   const handleClose = () => {
    setOpen(false);
   };
   const getColors = (brand) => {
    const brandLookup = newspaperData.filter((np) => np.name === brand);
    return {
        backgroundColor: brandLookup[0]?.background_color,
        color: brandLookup[0]?.color,
    };
   };
   const locationObject = useMemo(() => {
    const obj = {};
    newspaperLocationsObject.forEach((location) => {
        obj[location.value] = location.label;
    });
    return obj;})
    const getLocations = (locations) => {

        if (!locations) return '';
        // Wrap in array if it's not already one
        if (!Array.isArray(locations)) {
            locations = [locations];
        }

        const location_names = [];

        for (const location of locations) {
            const name = locationObject[+location]; // + converts to number
            if (name) location_names.push(name);
        }

        return location_names.length > 0 ? location_names.join(', ') : '';
    };
   const loadActiveCampaigns = async (reqObj) => {
    try {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops)) {
            setOpen(true)
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getAlphaActiveCampaigns`,
                method: "POST",
                responseType: "json",
                data: {...reqObj}
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                setCampaignList(res?.data?.length ? res?.data : []);
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
}
   const loadLanguages = async () => {
    try {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "query") {
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getLanguages`,
                method: "POST",
                responseType: "json",
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                console.log(res.data?.result);
                setLanguages(res?.data?.result?.length ? res?.data?.result : []);
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
   }
   const loadCategories = async () => {
    try {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "query") {
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getCategoriesAlpha`,
                method: "POST",
                responseType: "json",
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                setCategories(res?.data?.categories || []);
                setSubCategoriesMain(res?.data?.subCategories)
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
   }
   const loadLocations = async () => {
    try {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && (activeTab === "query" || activeTab === 'region')) {
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getLocations`,
                method: "POST",
                responseType: "json",
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                // if(activeTab === "region"){
                    setLocations(res?.data?.result?.length ? [...res?.data?.result] : []);
                    // setRegionLocations(res?.data?.result?.length ? res.data.result.map(item => item.value) : [])
                // }
                // else                        
                //     setLocations(res?.data?.result?.length ? [{label: "All", value: "All"},...res?.data?.result] : []);
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
   }
   const fetchNewsPapers = async () => {
    try {
        let res = await api({
            url: "/market/newspapers",
            method: "POST",
            responseType: "json",
            data: {},
        });
        if (res.code === 200) {
             setNewsPaperData([...(res.data.filter(item => item.name !== 'Way2news'))]);
             setW2nData([...(res.data.filter(item => item.name === 'Way2news'))][0])
            //setNewsPaperData([...res.data]);
        }
    } catch (error) {
        console.error(error);
    }
   }
   const userDetails = async () => {
    if (localStorage.getItem('role') === roles.salesperson) {

        let headDetails = await api({
            url: `/birdview/userDetails`,
            method: "POST",
            responseType: "json"
        });
        if (headDetails.data) {
            const userData = headDetails?.data?.result
            if (userData.user_type === -1) {
                setUserType("MainHead");
            }
            else if (userData.user_type === 1 && userData.region === -1 && userData.location === -1) {
                setUserType("NationalHead");
            }
            else if (userData.user_type === 2 && userData.region === -1 && userData.location === -1) {
                setUserType("LocalHead")

            }
            else if (userData.user_type === 1 && userData.region !== -1 && userData.location === -1) {
                setUserType("RegionHead");
            }
            else if (userData.user_type === 1 && userData.region !== -1 && userData.location !== -1) {
                setUserType("NationalUser")
            }
            else if (userData.user_type === 2 && userData.region !== -1) {
                setUserType("LocalUser")

            }

        }
    }
   }
   const loadRevenueStats = async (userType) => {
    try {
        if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) {
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/alpharevenueStats`,
                method: "POST",
                responseType: "json",
                data: { userType }
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                setRevenueStats(res?.data ? res?.data : {});
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
   }
   const getAlphaQueryResult = async()=>{
        try{
            let res = await api({
                url: `/competitor_reports/getAlphaQueryResult`,
                method: "POST",
                responseType: "json",
                data: {
                    queryDateRange,
                    queryLang,
                    queryMedia:queryMedia.length ? queryMedia : newspaperData.map(newspaper => newspaper.name),
                    queryCategory,
                    querySubCategory,
                    districts:selectedDistricts,
                    selectedQuery
                }
            })
            if(res.code === 200)
            {
                setQueryData(res.data?.data)
                settotalway2value(res.data?.w2n || 0)
                settotalcompetitorvalue(res.data?.competitor || 0)
            }
            setLoader(false); 
        }catch(err)
        {
            setLoader(false);
            if (err.response.status === 401)
            navigate("/")
        }
   }
   const loadRegionReports = async (regionDateRange) => {
    try {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "region") {
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getAlphaRegionReports`,
                method: "POST",
                responseType: "json",
                data: { regionDateRange, selectedSources}
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                setRegionReports(res?.data || {});
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
   }
   const loadRevenueData = async (dateRange, source, userType) => {
    try {
        if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && activeTab === "revenue_estimates") {
            setLoader(true);
            let res = await api({
                url: `/competitor_reports/getAlphaRevenueEstimates`,
                method: "POST",
                responseType: "json",
                data: {
                    dateRange,
                    source,
                    userType
                }
            });
            if (res?.code !== 200) {
                toast.error(res?.data?.message)
            } else {
                setRevenueEstimates(res?.data);
                setLoader(false);
            }
        }
    } catch (error) {
        setLoader(false);
        if (error.response.status === 401)
            navigate("/")
    }
   }        
        useEffect(() => {
            loadRevenueData(dateRange, source, userType);
        }, [dateRange, source, activeTab, userType]);
        useEffect(() => {
            loadRegionReports(regionDateRange, selectedSources);
        }, [activeTab, regionDateRange, selectedSources]);

        useEffect(() => {
            loadLanguages();
            loadCategories();
            loadLocations();
            loadRevenueStats(userType);
        }, [activeTab, userType])
        useEffect(() => {
            userDetails();
            fetchNewsPapers();
        }, [])
        useEffect(()=>{
            getAlphaQueryResult();
        },[queryDateRange, queryLang, queryCategory, queryLocation, queryMedia,activeTab,querySubCategory,selectedQuery])
   const handleDownload = ()=>{
    try {
        const tableData = [];
    
        // Add header row
        tableData.push(['District', 'W2N Revenue', 'Competitor Revenue']);
        
        // Add the rows for each district data
        Object.keys(queryData).forEach((item) => {
          const district = queryData[item];
          tableData.push([
            district?.dist_name || '-', 
          (district?.way2news || 0), 
          (district?.competitor || 0)
          ]);
        });
    
        // Add the total row at the end
        tableData.push([
          'Total',
        (totalway2value),
        (totalcompetitorvalue)
        ]);
    
        // Create a worksheet from the data array
        const ws = XLSX.utils.aoa_to_sheet(tableData);
        const wb = XLSX.utils.book_new(); // Create a new workbook
    
        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Revenue Report');
    
        // Export the workbook to a file
        XLSX.writeFile(wb, 'alpha_revenue_report.xlsx');
    } catch (error) {
        console.error(error)
        Toast('error', 'Error While Downloading')
    }
   }

   const fetchW2nAds = async(dist_ids)=>{
    setPreviewLoader(true)
    try {
        let res = await api({
            url:'/competitor_reports/getW2nAlphaAds',
            method:'POST',
            responseType:'json',
            data:{
                dateRange:queryDateRange,
                dist_ids,
            }
        })
        if(res.code === 200){
            setW2nPreviewData(res.data)
            setShowW2npreviews(true)
        }
    } catch (error) {
        console.error(error, "Error while fetcing W2n Ads")
    }
    finally{
        setPreviewLoader(false)
    }
   }

   const fetchCompAds = async(dist_ids)=>{
    setPreviewLoader(true)
    try {
         let res = await api({
            url:'/competitor_reports/getCompAlphaAds',
            method:'POST',
            responseType:'json',
            data:{
                dateRange:queryDateRange,
                dist_ids,
                selectedSources
            }
        })
        if(res.code === 200){
            setCompPreviewData(res.data)
            setShowPreviews(true)
        }
    } catch (error) {
        console.error(error, "Error while fetching Competitor ads")
    }
    finally{
        setPreviewLoader(false)
    }
   }

   useEffect(()=>{
        setSubCategories(subCategoriesMain.filter(category => queryCategory.includes(category.main_id)))
   },[queryCategory,subCategoriesMain])
   useEffect(()=>{
    getDistricts();
  },[])
   return (
    <div className="printData">
       <ScrollContainer>
       <table class="table table-bordered revenueEstimation">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        {
                            revenueStats.headers?.map(newspaper_name => 
                                (<th>{newspaper_name}</th>)
                            )
                        }
                        <th>Total Print Revenue</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Yesterday</td>
                        {
                            revenueStats.headers?.map(newspaper_name => {
                                let tempYest = revenueStats.yesterdayResult?.find(yesItem => yesItem.newspaper_name === newspaper_name)
                                if(tempYest){
                                    return (<td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}}  data-toggle="tooltip" data-placement="top" title={tempYest.revenue}>₹{formatAmount(tempYest.revenue)}</td>)
                                }
                                else
                                    return <td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}}>₹0</td>
                            })
                        }
                        <td class="total" data-toggle="tooltip" data-placement="top" title={revenueStats?.yesterdayTotal}>₹{formatAmount(revenueStats?.yesterdayTotal)}</td>
                    </tr>
                    <tr>
                        <td>This Month</td>
                        {
                            revenueStats.headers?.map(newspaper_name => {
                                let tempthismonth = revenueStats.thisMonthResult?.find(thismonthItem => thismonthItem.newspaper_name === newspaper_name)
                                if(tempthismonth)
                                    return (<td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}} data-toggle="tooltip" data-placement="top" title={tempthismonth.revenue}>₹{formatAmount(tempthismonth.revenue)}</td>)
                                else
                                    return <td style={{color: newspaperData?.find(item => item.name === newspaper_name)?.background_color || ""}}>₹0</td>
                            })
                        }
                        {/* <td class="sakshi">₹{formatAmount(revenueStats.this_month_sakshi)}</td>
                        <td class="eenadu">₹{formatAmount(revenueStats.this_month_dinathanthi)}</td> */}
                        <td class="total" data-toggle="tooltip" data-placement="top" title={revenueStats?.thisMonthTotal}>₹ {formatAmount(revenueStats?.thisMonthTotal)}</td>
                    </tr>
                </tbody>
       </table>
       </ScrollContainer>
       <div>
       <SlTabGroup >
                    {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && <SlTab slot="nav" panel="revenue_estimates" onClick={() => { handleTabClick("revenue_estimates") }}>Revenue Estimates
                    </SlTab>}
                    {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && <SlTab slot="nav" panel="region" onClick={() => { handleTabClick("region") }}>Region
                    </SlTab>}
                    {(localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson || localStorage.getItem("role") === roles.ops) && <SlTab slot="nav" panel="query" onClick={() => { handleTabClick("query") }}>Query
                    </SlTab>}

                    <SlTabPanel name="revenue_estimates">
                        <div className="cc-padding">
                            <div className="overflow-x-auto mb-4">

                                {/* <div class="selectors"> */}
                                <div className='flex gap-4 mb-4'>
                                    <div>
                                        <SlSelect
                                            className='w-full'
                                            placeholder="Select Media"
                                            name="source"
                                            size="medium"
                                            value={source}
                                            onSlChange={(e) => { setSource(e.target.displayLabel) }}

                                        >
                                            <SlOption key={0} value={'Media'}>Media</SlOption>
                                            {/* <SlOption key={0} value={'Channel'}>Channel</SlOption> */}
                                        </SlSelect>
                                    </div>

                                    <div className='border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66'>
                                        <Datepicker
                                            classNames="form-input"
                                            value={dateRange}
                                            primaryColor={"cyan"}
                                            showShortcuts={true}
                                            useRange={true} // Allow date range selection
                                            configs={{
                                                shortcuts: {
                                                    today: "today",
                                                    yesterday: "yesterday",
                                                    currentMonth: "currentMonth",
                                                    pastMonth: "lastMonth",

                                                }
                                            }}
                                            onChange={handleDateRange}
                                        />
                                    </div>

                                </div>
                                <div class="indiana-scroll-container indiana-scroll-container--hide-scrollbars">
                                    <table class="table table-bordered monthDate">
                                        <thead>
                                            <tr>
                                                <th>Edition</th>
                                                <th>Revenue</th>
                                                <th>No Of Ads</th>
                                                <th>Avg Revenue</th>
                                            </tr>
                                        </thead>
                                        {revenueEstimates.overAllData?.length ? <tbody>
                                            {
                                                 revenueEstimates.overAllData.map((item, index) => {
                                                    return(
                                                        <tr>
                                                        <td className={index%3 === 0 ? "ap" : index%3 ===1 ? "ts" : "hyd"}>{item.edition}</td>
                                                        <td data-toggle="tooltip" data-placement="top" title={item.estimated_value}>₹ {formatAmount(item.estimated_value)} ({calculatePercentage(item.estimated_value, revenueEstimates.totalRevenue)}%)</td>
                                                        <td>{item.ads}</td>
                                                        <td>{(item.estimated_value / item.ads).toFixed(2)}</td>
                                                        </tr>
                                                    )
                                                }) 
                                            }
                                        </tbody> : <NoDataFound colspan="8" />}
                                        <tfoot>
                                            <tr>
                                                <td>Total</td>
                                                <td data-toggle="tooltip" data-placement="top" title={revenueEstimates.totalRevenue}>₹ {formatAmount(revenueEstimates.totalRevenue)}</td>
                                                <td>{revenueEstimates.totalAds}</td>
                                                <td>{(revenueEstimates.totalRevenue / revenueEstimates.totalAds).toFixed(2)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </SlTabPanel>

                    <SlTabPanel name="region">
                        <div className="prntDataRegion">
                            <div className="overflow-x-auto mb-4">
                                {/* <h1>Region Table</h1> */}
                                <div className='flex gap-4 mb-4'>

                                    <div>
                                        <SlSelect
                                            className=' mb-3 w-full'
                                            placeholder="Select Media"
                                            name="selectedSources"
                                            size="medium"
                                            value={selectedSources}
                                            onSlChange={(e) => { handleSourceChange(e.target.value); }}
                                            multiple
                                            clearable
                                        >
                                            {newspaperData?.map(item => (
                                                <SlOption key={item.name} value={item.name}>
                                                    {item.name}
                                                </SlOption>
                                            ))}

                                        </SlSelect>
                                    </div>

                                    <div className='border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 datePicker'>
                                        <Datepicker
                                            classNames="form-input"
                                            value={regionDateRange}
                                            primaryColor={"cyan"}
                                            showShortcuts={true}
                                            useRange={true} // Allow date range selection
                                            configs={{
                                                shortcuts: {
                                                    today: "today",
                                                    yesterday: "yesterday",
                                                    currentMonth: "currentMonth",
                                                    pastMonth: "lastMonth",

                                                }
                                            }}
                                            onChange={handleRegionDateRange}
                                        />
                                    </div>   
                                </div>
                                <table class="table table-bordered monthDate specialTable regionTable regionTableAlpha">
                                    {dateArray?.length && !loader ? (<>
                                        <thead>
                                            <tr>
                                                <th rowSpan={2} class="first">&nbsp;</th>
                                                {selectedSources.map(item => <th colSpan={3}><img src={newspaperData.find(newsItem => newsItem.name === item)?.logo} alt="logo" /></th>)}
                                                <th colSpan={3}><img src={w2nData?.logo}  alt='w2nlogo'></img></th>
                                                <th colSpan={3}> Comp Total</th>
                                            </tr>
                                            <tr>
                                            {Array.from({ length: selectedSources.length + 2 }).map((_, index) => (
                                                <React.Fragment key={index}>
                                                <th>Amount</th>
                                                <th>Ads</th>
                                                <th>Avg</th>
                                                </React.Fragment>
                                            ))}
                                            </tr>

                                        </thead>

                                        <tbody>
                                            {dateArray.map((date, index) => {

                                                let dateFilterReport = regionReports?.regularData?.length ? regionReports?.regularData?.filter(item => item.date === date) : []
                                                let w2nReport = regionReports?.w2nData?.length ? regionReports?.w2nData?.filter(item => item.date === date) : []
                                                let totalDateFilterReport = regionReports?.totalDateWiseData?.find(item => item.date === date) || {}
                                                return (
                                                    <tr key={index}>
                                                        <td className="first">{date}</td>
                                                        {selectedSources.map(newsPaper => {
                                                            let item = dateFilterReport.find(dateItem => dateItem.newspaper_name === newsPaper);
                                                            return (<><td data-toggle="tooltip" data-placement="top" title={item?.total_estimated_value || 0}>₹{formatAmount(item?.total_estimated_value || 0)}</td>
                                                                <td><div class="brands">
                                                                    <div class="count">
                                                                        <img src={LocationImage} alt="" />
                                                                        <p style={{ cursor: "pointer" }} onClick={async () => {
                                                                            loadActiveCampaigns({ dateRange: { startDate: date, endDate: date }, newspapers: [newsPaper] })}} >
                                                                            {item?.count || 0}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                </td>
                                                                <td title={item?.total_estimated_value / item?.count}>{formatAmount((item?.total_estimated_value || 0) / (item?.count || 0))}</td>
                                                                </>)


                                                        })}
                                                        <td title={(w2nReport[0]?.amount || 0)}>₹ {formatAmount(w2nReport[0]?.amount || 0)}</td>
                                                        <td>{w2nReport[0]?.ads || 0}</td>
                                                        <td>{formatAmount((w2nReport[0]?.amount || 0) / (w2nReport[0]?.ads || 0))}</td>
                                                        <td data-toggle="tooltip" data-placement="top" title={totalDateFilterReport.total_estimated_value || 0}>₹{formatAmount(totalDateFilterReport.total_estimated_value || 0)}</td>
                                                        <td><div class="brands">
                                                            <div class="count">
                                                                <img src={LocationImage} alt="" />
                                                                <p style={{ cursor: "pointer" }}>
                                                                    {totalDateFilterReport?.count || 0}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        </td>
                                                        <td title={(totalDateFilterReport?.total_estimated_value || 0) / (totalDateFilterReport?.count || 0)}>{formatAmount((totalDateFilterReport?.total_estimated_value || 0) / (totalDateFilterReport?.count || 0))}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                        <tfoot>
                                            <tr >
                                                <td>Total</td>
                                                {selectedSources.map(newsPaper => {
                                                    let totalNewsData = regionReports?.totalNewsWiseData?.find(item => item.newspaper_name === newsPaper)
                                                    return <><td data-toggle="tooltip" data-placement="top" title={totalNewsData?.total_estimated_value || 0}>₹{formatAmount(totalNewsData?.total_estimated_value || 0)}</td><td><div class="brands flex-wrap">
                                                        
                                                        <div class="count">
                                                            <img src={LocationImage} alt="" />
                                                            <p style={{ cursor: "pointer" }}>
                                                                {totalNewsData?.count || 0}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    </td>
                                                    <td title={totalNewsData?.total_estimated_value || 0 / totalNewsData?.count || 0}>{formatAmount((totalNewsData?.total_estimated_value || 0) / (totalNewsData?.count || 0))}</td>
                                                    </>
                                                }
                                                )}
                                                <td title={regionReports.way2newsDataTotal?.total || 0}>₹ {formatAmount(regionReports.way2newsDataTotal?.total || 0)}</td>
                                                <td>{regionReports.way2newsDataTotal?.ads || 0}</td>
                                                <td title={regionReports.way2newsDataTotal?.total || 0 / regionReports.way2newsDataTotal?.ads || 0}>{formatAmount((regionReports.way2newsDataTotal?.total || 0) / (regionReports.way2newsDataTotal?.ads || 0))}</td>
                                                <td data-toggle="tooltip" data-placement="top" title={regionReports?.overAllTotalData?.total_estimated_value || 0}>₹{formatAmount(regionReports?.overAllTotalData?.total_estimated_value || 0)}</td>
                                                <td><div class="brands flex-wrap">
                                                    <div class="count">
                                                        <img src={LocationImage} alt="" />
                                                        <p style={{ cursor: "pointer" }}>
                                                            {regionReports?.overAllTotalData?.count || 0}
                                                        </p>
                                                    </div>
                                                </div>
                                                </td>
                                                <td title={regionReports?.overAllTotalData?.total_estimated_value || 0 / regionReports?.overAllTotalData?.count || 0}>{formatAmount((regionReports?.overAllTotalData?.total_estimated_value || 0) / (regionReports?.overAllTotalData?.count || 0))}</td>
                                            </tr>
                                        </tfoot>
                                    </>) : !dateArray?.length && !loader ? (
                                        <NoDataFound colspan={3} />
                                    ) : (
                                        <TableSkelton colspan={3} />
                                    )}
                                </table>
                            </div>
                        </div>
                    </SlTabPanel>

                    <SlTabPanel name="query">
                        <div className="customHeight">
                            <div>
                                <SlSelect
                                    style={{ width: 650 }}
                                    className=' mb-3 w-full'
                                    placeholder="Select Language"
                                    name="queryLang"
                                    size="medium"
                                    value={queryLang}
                                    onSlChange={(e) => {handleQueryLang(e.target.value); }}
                                    multiple
                                    clearable

                                >
                                    {languages?.map(item => (
                                        <SlOption key={item.lang_id} value={item.lang_id}>
                                            {item.lang_name}
                                        </SlOption>
                                    ))}

                                </SlSelect>
                            </div>
                            {/* <div style={{ width: 650 }}>
                                <Select
                                    className='mb-3'
                                    placeholder="Select Location"
                                    name="queryLocation"
                                    size="medium"
                                    value={locations.filter(
                                        (option) => queryLocation.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setQueryLocation(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={locations}
                                    isMulti
                                />
                            </div> */}

                            <div style={{ width: 650 }}>

                                <Select
                                    className='mb-3'
                                    placeholder="Select Media/Channel"
                                    name="queryMedia"
                                    size="medium"
                                    value={newspaperData.map(item => {return {label: item.name, value: item.name}}).filter(
                                        (option) => queryMedia.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setQueryMedia(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={newspaperData.map(item => {return {label: item.name, value: item.name}})}
                                    isMulti
                                />
                            </div>
                            <div style={{ width: 650 }}>
                            <Select
                                className='mb-3'
                                placeholder="Select District"
                                size="medium"
                                value={selectedDistricts || null}   // only for this row
                                onChange={(e)=>{setSelectedDistricts(e)}}
                                options={districts}
                                getOptionLabel={(option) => option.dist_name}
                                getOptionValue={(option) => option.dist_id}
                                isClearable
                            />
                            </div>

                            <div style={{ width: 650 }}>
                                <Select
                                    className='mb-3'
                                    placeholder="Select Category"
                                    name="queryCategory"
                                    size="medium"
                                    value={categories.map(item => {return {label: item.category_name, value: item.category_id}}).filter(
                                        (option) => queryCategory.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setQueryCategory(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={categories.map(item => {return {label: item.category_name, value: item.category_id}})}
                                    isMulti
                                />
                            </div>
                            <div style={{ width: 650 }}>
                                <Select
                                    className='mb-3'
                                    placeholder="Select Sub Category"
                                    name="querySubCategory"
                                    size="medium"
                                    value={subCategories.map(item => {return {label: item.category_name, value: item.category_id}}).filter(
                                        (option) => querySubCategory.indexOf(option.value) >= 0
                                      )}
                                    onChange={(selected) => {
                                        setQuerySubCategory(
                                          selected ? selected.map((item) => item.value) : []
                                        );
                                      }}                                    
                                    options={subCategories.map(item => {return {label: item.category_name, value: item.category_id}})}
                                    isMulti
                                />
                            </div>

                            <div className='border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66 pickDate customFwidth'>
                                <Datepicker
                                    classNames="form-input"

                                    value={queryDateRange}
                                    primaryColor={"cyan"}
                                    showShortcuts={true}
                                    useRange={true} // Allow date range selection
                                    configs={{
                                        shortcuts: {
                                            today: "today",
                                            yesterday: "yesterday",
                                            currentMonth: "currentMonth",
                                            pastMonth: "lastMonth",

                                        }
                                    }}
                                    onChange={handleQueryDateRange}
                                />
                            </div>
                            <div className="addMore d-flex justify-between items-center w-full">
                                <ul className="chooseMore">
                                    <li>
                                        <input type="checkbox" id="campaigns" value="all_campaigns" checked={selectedQuery === 'district_wise'}
                                            onChange={() => setSelectedQuery("district_wise")} />
                                        <label htmlFor="campaigns">District Wise</label>
                                    </li>
                                  
                                    <li>
                                        <input type="checkbox" id="category" value="category_wise" checked={selectedQuery === 'category_wise'}
                                            onChange={() => setSelectedQuery("category_wise")} />
                                        <label htmlFor="category">Category Wise</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" id="datewise" value="date_wise" checked={selectedQuery === 'date_wise'}
                                            onChange={() => setSelectedQuery("date_wise")} />
                                        <label htmlFor="datewise">Date Wise</label>
                                    </li>
                                </ul>
                            </div>
                            <div className='flex justify-end font-bold mb-2'>
                                <SlButton size='medium' variant='primary' onClick={handleDownload}>Download</SlButton>
                            </div>
                            <table className='table table-bordered splTable'>
                                <thead className="sticky top-0">
                                    <tr>
                                    <th>District</th>
                                    <th>W2N Revenue</th>
                                    <th>Competitor Revenue</th>
                                    </tr>
                                </thead>

                                <tfoot>
                                    <tr>
                                    <th>Total</th>
                                    <th data-toggle="tooltip" data-placement="top" title={totalway2value}>
                                        ₹{formatAmount(totalway2value)}
                                    </th>
                                    <th data-toggle="tooltip" data-placement="top" title={totalcompetitorvalue}>
                                        ₹{formatAmount(totalcompetitorvalue)}
                                    </th>
                                    </tr>
                                </tfoot>
                                {Object.keys(queryData)?.length&& !loader ? (
                                    <tbody>
                                    {Object.keys(queryData)?.map((item, index) => (
                                        <tr key={index} className="group/details hover:bg-slate-100">
                                        <td>{queryData[item]?.dist_name || '-'}</td>
                                        <td title={queryData[item]?.way2news || 0} onClick={()=>{fetchW2nAds(queryData[item]?.dist_ids)}}>{formatAmount(queryData[item]?.way2news || 0)}</td>
                                        <td title={queryData[item]?.competitor || 0} onClick={()=>{fetchCompAds(queryData[item]?.dist_ids)}}>{formatAmount(queryData[item]?.competitor || 0)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                ) : !Object.keys(queryData)?.length && !loader ? (
                                    <NoDataFound colspan="3" />
                                ) : (
                                    <TableSkelton colspan="3" />
                                )}
                              

                                </table>

                        </div>
                    </SlTabPanel >
        </SlTabGroup >
        <SlDrawer label="Active Brands" open={open} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} style={{ '--size': '80vw' }}>
                <div>
                    {/* 
                    <ul>
                        {brandsList.map((brand, index) => (
                            <li key={index}>{index + 1}  .  {brand}</li>
                        ))}
                    </ul> */}

                    {
                        CampaignList?.length && !loader ? (
                            <div class="birdviewWrapper">
                                <ul class="birdview">
                                    {CampaignList.map((item, index) => {
                                        return (
                                            <li className='w-[25%]'>
                                                <div class="theme">
                                                    {(item?.image_url) ? (<img src={item.image_url} alt="adImage" />) : (<img src={NoImage} alt="adImage" />)}
                                                    <div class="blur"> {(item?.image_url) ? (<img src={item.image_url} alt="adImage" />) : (<img src={NoImage} alt="adImage" />)}</div>
                                                    <div class="publisher">
                                                        {item?.newspaper_name ? (
                                                            <h6 style={getColors(item?.newspaper_name)}>
                                                                {item.newspaper_name}
                                                            </h6>
                                                        ) : null}
                                                        {(item?.ad_type === "Local") ? (<h6 class="local">{item.ad_type}</h6>) : ((item?.ad_type === "National") ? (<h6 class="national">{item.ad_type}</h6>) : (<h6 class="districts">{item.ad_type}</h6>))}
                                                    </div>
                                                    <p className="location"><img src={LocationSVG} alt="location_name" title={item.location} />{getLocations(item.location)}</p>
                                                    <p class="estimation">Est Val: <strong>{item.estimated_value || 0}</strong></p>
                                                    {item.image_url ? (<Button className="previewBtn" variant="neutral"
                                                        onClick={() => { setImgSrc(item.image_url); setSee(true) }}
                                                    >
                                                        Preview
                                                    </Button>) : null}
                                                </div>
                                                <div class="description">
                                                    {(item?.page_no) ? (<p>Page {item.page_no} : {formatDate(item.date)}</p>) : (<p>Page -  : {formatDate(item.date)}</p>)}
                                                    <h1>{item.campaign_name || "-"}</h1>
                                                    <h5>Edition : {item.edition || " "}</h5>
                                                    <h5>Ad Format : {item.ad_format || " "}</h5>
                                                    {/* <h5>Brand name : {item.brand_name || " "}</h5> */}
                                                </div>                                               

                                            </li>)
                                    })}
                                </ul>
                            </div>
                        ) : !CampaignList?.length && !loader ? (
                            <NoDataFound colspan="17" />
                        ) : (
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        )
                    }
                </div>

            </SlDrawer >

            <Modal className="birdview-image-preview" show={see} onHide={() => setSee(false)}>
                <Modal.Header closeButton>Image Preview
                </Modal.Header>
                <Modal.Body>
                    <img src={imgSrc} alt="" />
                </Modal.Body>
            </Modal >
       </div>
       <AdsPreviewer showCompPreviews={showPreviews} showW2nPreviews={showW2nPreviews} data={compPreviewData} w2nData={W2nPreviewData} loader={previewLoader} setShowCompPreviews={setShowPreviews} setShowW2npreviews={setShowW2npreviews} setData={setCompPreviewData} setw2nData={setW2nPreviewData}/>
    </div>
   )
}
export default AlphaCompetitor_reports;